import React from 'react'
import './index.scss'
import checkbox from '../../images/travel/checkbox-elipse.svg'

export interface ITravelAdvantages {
    icon: any
    text: string
}

const TravelAdvantages: React.FC<ITravelAdvantages> = ({icon, text}) => {
    return (
        <div className={'travel-advantages'}>
            <div className={'travel-advantages__icons'}>
                <img className={'travel-advantages__icons_main-icon'} src={icon} alt="icon"/>
                <img className={'travel-advantages__icons_checkbox-icon'} src={checkbox} alt="icon"/>
            </div>

            <p className={'travel-advantages__text'}>{text}</p>
        </div>
    );
};

export default TravelAdvantages